<!-- <app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"> -->
<form [formGroup]="form" *ngIf="form" class="madar--v2">
  <mat-card>
    <mat-card-content class="p-3 mt-0">
      <app-row>
        <mat-label>{{ "Filter.Form.CustomerName" | translate }}</mat-label>
        <app-lazy-dropdown
          [valuePath]="'id'"
          [formControlName]="'customer'"
          [lookup]="lookupType.Customers"
          [filter]="addAllToOptions"
        ></app-lazy-dropdown>
      </app-row>

      <app-row>
        <mat-label class="field-label">{{ "Filter.Form.CreatedBy" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="form-control-full-width">
          <mat-select formControlName="creator">
            <app-dropdown-search formControlName="creatorSearchTerm"></app-dropdown-search>
            <mat-option [value]="sharedConstants.ALL">{{ 'Options.ALL' | translate }}</mat-option>
            <mat-option *ngFor="let item of creators | sortDropdown" [value]="item.id">{{ item.dropDownDisplayName }}</mat-option>
          </mat-select>
        </mat-form-field>
      </app-row>
    </mat-card-content>
    <mat-divider></mat-divider>
    <mat-card-actions class="justify-flex-end p-3">
        <button mat-button color="primary" type="button" (click)="onReset()">{{'shared.Buttons.Reset' | translate}}</button>
        <button mat-flat-button color="primary" type="button" (click)="onApply()">{{'shared.Buttons.Apply' | translate}}</button>
    </mat-card-actions>
  </mat-card>
</form>
<!-- </app-state-section> -->
